// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var ScoreCardSetting$ReactHooksTemplate = require("./scoreCardSetting.res.js");
var ScoreCardChartAttribute$ReactHooksTemplate = require("./scoreCardChartAttribute.res.js");

function ScoreCardComponent(props) {
  var onClick = props.onClick;
  var chartAttribute = props.chartAttribute;
  var chartId = props.chartId;
  var match = ScoreCardChartAttribute$ReactHooksTemplate.onClick(chartAttribute);
  var cursorStyle;
  cursorStyle = typeof match !== "object" ? "" : "cursor-pointer hover:border hover:border-1 hover:border-purple-800";
  var setting = ScoreCardChartAttribute$ReactHooksTemplate.settings(chartAttribute);
  var titleTextColor;
  if (setting !== undefined) {
    switch (setting.TAG) {
      case "ChartSetting" :
      case "MapSetting" :
          titleTextColor = "text-white";
          break;
      case "ScoreCardSetting" :
          titleTextColor = ScoreCardSetting$ReactHooksTemplate.titleTextColor(setting._0);
          break;
      
    }
  } else {
    titleTextColor = "text-charcoal";
  }
  var setting$1 = ScoreCardChartAttribute$ReactHooksTemplate.settings(chartAttribute);
  var background;
  if (setting$1 !== undefined) {
    switch (setting$1.TAG) {
      case "ChartSetting" :
      case "MapSetting" :
          background = "bg-white";
          break;
      case "ScoreCardSetting" :
          background = ScoreCardSetting$ReactHooksTemplate.background(setting$1._0);
          break;
      
    }
  } else {
    background = "bg-aliceblue";
  }
  var setting$2 = ScoreCardChartAttribute$ReactHooksTemplate.settings(chartAttribute);
  var boxBackground;
  if (setting$2 !== undefined) {
    switch (setting$2.TAG) {
      case "ChartSetting" :
      case "MapSetting" :
          boxBackground = "bg-white";
          break;
      case "ScoreCardSetting" :
          boxBackground = ScoreCardSetting$ReactHooksTemplate.boxBackground(setting$2._0);
          break;
      
    }
  } else {
    boxBackground = "bg-verdigris";
  }
  var setting$3 = ScoreCardChartAttribute$ReactHooksTemplate.settings(chartAttribute);
  var innerContainerBackground;
  if (setting$3 !== undefined) {
    switch (setting$3.TAG) {
      case "ChartSetting" :
      case "MapSetting" :
          innerContainerBackground = "bg-white";
          break;
      case "ScoreCardSetting" :
          innerContainerBackground = ScoreCardSetting$ReactHooksTemplate.innerContainerBackground(setting$3._0);
          break;
      
    }
  } else {
    innerContainerBackground = "bg-azureishwhite";
  }
  var setting$4 = ScoreCardChartAttribute$ReactHooksTemplate.settings(chartAttribute);
  var borderColor;
  if (setting$4 !== undefined) {
    switch (setting$4.TAG) {
      case "ChartSetting" :
      case "MapSetting" :
          borderColor = "bg-white";
          break;
      case "ScoreCardSetting" :
          borderColor = ScoreCardSetting$ReactHooksTemplate.innerContainerBackground(setting$4._0);
          break;
      
    }
  } else {
    borderColor = "border-verdigris";
  }
  var formatter = function (value) {
    if (Math.abs(value) > 999.0) {
      return (value / 1000.0).toFixed(1) + "K";
    } else {
      return value.toString();
    }
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    className: "bg-white h-8-px w-8-px m-auto rounded-lg"
                                  }),
                              className: "min-w-30-px h-30-px " + boxBackground + " flex rounded-lg mr-2"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: ScoreCardChartAttribute$ReactHooksTemplate.title(chartAttribute),
                                    className: "m-auto"
                                  }),
                              className: "flex"
                            })
                      ],
                      className: "animated fadeIn p-4 pb-0\n      text-base font-semibold " + titleTextColor + " leading-none flex"
                    }),
                JsxRuntime.jsx("div", {
                      children: $$Array.of_list(Belt_List.map(ScoreCardChartAttribute$ReactHooksTemplate.data(chartAttribute), (function (param) {
                                  var value = param[1];
                                  var id = param[0];
                                  return JsxRuntime.jsxs("div", {
                                              children: [
                                                value !== undefined ? JsxRuntime.jsx(JsxRuntime.Fragment, {
                                                        children: Caml_option.some(JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    formatter(value),
                                                                    JsxRuntime.jsx("span", {
                                                                          children: value.toString().toLocaleUpperCase(),
                                                                          className: "tooltiptext " + boxBackground + " text-base"
                                                                        })
                                                                  ],
                                                                  className: "font-semibold h-24-px text-xl leading-tight text-center\n                m-auto text-22-px mt-17-px tooltip"
                                                                }))
                                                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {
                                                        children: Caml_option.some(JsxRuntime.jsx("div", {
                                                                  children: "--",
                                                                  className: "font-semibold h-24-px text-xl leading-tight\n                text-center m-auto text-22-px mt-17-px"
                                                                }))
                                                      }),
                                                JsxRuntime.jsx("div", {
                                                      children: id,
                                                      className: "text-xs pt-8-px font-normal leading-tight text-charcoal tracking-normal"
                                                    })
                                              ],
                                              className: "text-center " + innerContainerBackground + " w-110-px h-78-px rounded mt-2"
                                            }, id);
                                }))),
                      className: "flex flex-wrap gap-2 px-4 animated fadeIn justify-evenly items-center"
                    })
              ],
              className: "box rounded-lg h-154-px " + background + " " + cursorStyle + "\n    border " + borderColor,
              onClick: (function (param) {
                  Curry._3(onClick, Belt_Option.getWithDefault(Caml_array.get(Js_string.splitByRe(/:/, ScoreCardChartAttribute$ReactHooksTemplate.title(chartAttribute)), 0), ""), chartId, ScoreCardChartAttribute$ReactHooksTemplate.onClick(chartAttribute));
                })
            });
}

var make = ScoreCardComponent;

exports.make = make;
/* react/jsx-runtime Not a pure module */
